__turbopack_context__.v({
  "author": "ReviewsSlider-module-scss-module__FsL6KG__author",
  "authorInfo": "ReviewsSlider-module-scss-module__FsL6KG__authorInfo",
  "content": "ReviewsSlider-module-scss-module__FsL6KG__content",
  "image": "ReviewsSlider-module-scss-module__FsL6KG__image",
  "imageWrapper": "ReviewsSlider-module-scss-module__FsL6KG__imageWrapper",
  "name": "ReviewsSlider-module-scss-module__FsL6KG__name",
  "position": "ReviewsSlider-module-scss-module__FsL6KG__position",
  "slide": "ReviewsSlider-module-scss-module__FsL6KG__slide",
  "slideTitle": "ReviewsSlider-module-scss-module__FsL6KG__slideTitle",
  "sliderWrapper": "ReviewsSlider-module-scss-module__FsL6KG__sliderWrapper",
  "swiper": "ReviewsSlider-module-scss-module__FsL6KG__swiper",
  "text": "ReviewsSlider-module-scss-module__FsL6KG__text",
  "title": "ReviewsSlider-module-scss-module__FsL6KG__title",
});
